import { useEffect, useRef } from "react";
import { Radio } from "@phosphor-icons/react";

const KIND_STYLE = {
  onscene:  { tag: "10-97", color: "#FFD60A", label: "UNIT ON SCENE" },
  assessed: { tag: "10-23", color: "#FF9F0A", label: "SCENE ASSESSED" },
  allunits: { tag: "10-23", color: "#0A84FF", label: "ALL UNITS ON SCENE" },
  resolved: { tag: "10-24", color: "#30D158", label: "INCIDENT RESOLVED" },
  dispatch: { tag: "10-76", color: "#0A84FF", label: "UNIT DISPATCHED" },
  recall:   { tag: "10-22", color: "#9CA3AF", label: "UNIT RECALLED" },
  expired:  { tag: "10-7",  color: "#FF453A", label: "CALL EXPIRED" },
  build:    { tag: "ADMIN", color: "#22C55E", label: "STATION BUILT" },
  share:    { tag: "MUTUAL", color: "#FB923C", label: "HELP REQUEST" },
  daily:    { tag: "ADMIN", color: "#22D3EE", label: "DAILY BONUS" },
  achievement: { tag: "ADMIN", color: "#EAB308", label: "ACHIEVEMENT" },
};

function fmtTime(ts) {
  const d = new Date(ts);
  const hh = String(d.getHours()).padStart(2, "0");
  const mm = String(d.getMinutes()).padStart(2, "0");
  const ss = String(d.getSeconds()).padStart(2, "0");
  return `${hh}:${mm}:${ss}`;
}

/**
 * RadioPanel — always-on dispatch log embedded in the bottom bar.
 * No collapse toggle (moved to the Mutual Aid side panel).
 */
export default function RadioPanel({ entries }) {
  const listRef = useRef(null);

  useEffect(() => {
    const el = listRef.current;
    if (!el) return;
    el.scrollTop = el.scrollHeight;
  }, [entries]);

  return (
    <aside
      className="border-l border-white/10 w-80 flex flex-col h-full bg-[#0F1115]"
      data-testid="radio-panel"
    >
      <div className="flex items-center justify-between px-3 py-2 border-b border-white/5 shrink-0">
        <div className="flex items-center gap-1.5">
          <Radio size={12} className="text-emerald-400" />
          <h2 className="mono text-[10px] uppercase tracking-[0.25em] text-zinc-300 font-semibold">
            Radio
          </h2>
        </div>
        <div className="flex items-center gap-1.5">
          <span className="w-1.5 h-1.5 bg-emerald-400 animate-pulse" />
          <span className="mono text-[9px] text-emerald-400">CH 1</span>
        </div>
      </div>
      <div
        ref={listRef}
        className="flex-1 overflow-y-auto"
        data-testid="radio-log"
      >
        {entries.length === 0 && (
          <div className="p-4 text-center mono text-[10px] text-zinc-600 uppercase tracking-widest">
            — channel quiet —
          </div>
        )}
        {entries.map((e) => {
          const k = KIND_STYLE[e.kind] || KIND_STYLE.onscene;
          return (
            <div
              key={e.id}
              data-testid={`radio-entry-${e.id}`}
              className="border-b border-white/5 px-3 py-1.5"
              style={{ borderLeft: `3px solid ${k.color}` }}
            >
              <div className="flex items-baseline gap-2 mb-0.5">
                <span
                  className="mono text-[9px] font-bold uppercase tracking-widest px-1 py-0.5"
                  style={{ background: k.color, color: "#050505" }}
                >
                  {k.tag}
                </span>
                <span className="mono text-[8px] uppercase tracking-widest text-zinc-500 flex-1 truncate">
                  {k.label}
                </span>
                <span className="mono text-[8px] text-zinc-600 tabular-nums">
                  {fmtTime(e.ts)}
                </span>
              </div>
              <div className="text-[11px] leading-snug text-white">{e.text}</div>
            </div>
          );
        })}
      </div>
    </aside>
  );
}
